import {Alert} from 'react-bootstrap';

import { 
  ExclamationCircle
} from 'react-bootstrap-icons';

export default function NoResultsComponent() {
  return (
    <Alert className="bg-info text-white"><ExclamationCircle size={16} className="mb-1 mr-1" />No Results</Alert>
  )
}